'use strict';

var accordion = {};

exports.__exports = accordion;
//# sourceMappingURL=accordion.cjs.map
